/// <reference path="../appDashboard.ts" />
var managerMenu = function () {
    return {
        restrict: 'E',
        replace: false,
        scope: {
            promiseUserPopulated: "=",
            promiseCommercialCalendar: "="
        },
        templateUrl: '/templates/manager-menu.html',
        controller: 'DashboardMenuBlockController as menuBlockController',
    };
};

appDashboard.directive("managerMenu", managerMenu);
